
import React from 'react';
import { FormProvider } from 'react-hook-form';
import { 
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import FilterDropdowns from './FilterDropdowns';
import SwitchesGroup from '@/components/form/services/SwitchesGroup';
import { Filter } from '@/hooks/search';

interface FiltersProps {
  filters: Filter;
  methods: any;
  onFilterChange: (filterName: keyof Filter, value: any) => void;
  onApplyFilters: () => void;
  onClearFilters: () => void;
}

const Filters: React.FC<FiltersProps> = ({ 
  filters, 
  methods, 
  onFilterChange, 
  onApplyFilters, 
  onClearFilters 
}) => {
  // Handle multi-select change for type, category, region, locality, status, and segment
  const handleMultiSelectChange = (field: 'type' | 'category' | 'region' | 'locality' | 'status' | 'substatus' | 'segment', value: string) => {
    const currentValues = [...filters[field]];
    const valueIndex = currentValues.indexOf(value);
    
    if (valueIndex !== -1) {
      // Remove value if already selected
      currentValues.splice(valueIndex, 1);
    } else {
      // Add value if not already selected
      currentValues.push(value);
    }
    
    onFilterChange(field, currentValues);
  };

  // Remove a multi-select value
  const removeMultiSelectValue = (field: 'type' | 'category' | 'region' | 'locality' | 'status'| 'substatus' | 'segment', value: string) => {
    const currentValues = [...filters[field]];
    const valueIndex = currentValues.indexOf(value);
    
    if (valueIndex !== -1) {
      currentValues.splice(valueIndex, 1);
      onFilterChange(field, currentValues);
    }
  };

  // Handle accessibility toggle change
  const handleAccessibilityChange = (checked: boolean) => {
    onFilterChange('accessibility', checked ? 'Si' : 'No');
  };

  return (
    <FormProvider {...methods}>
      <Card>
        <CardContent className="pt-6">
          <Accordion type="single" collapsible className="mb-4">
            <AccordionItem value="filters">
              <AccordionTrigger className="py-2">Búsqueda avanzada</AccordionTrigger>
              <AccordionContent>
                {/* Filter Dropdowns */}
                <FilterDropdowns 
                  filters={filters}
                  onFilterChange={onFilterChange}
                  handleMultiSelectChange={handleMultiSelectChange}
                  removeMultiSelectValue={removeMultiSelectValue}
                />
                
                {/* Services Switch Group */}
                <SwitchesGroup 
                  onAccessibilityChange={handleAccessibilityChange}
                />
                
                {/* Action Buttons */}
                <div className="flex justify-end gap-2">
                  <Button variant="outline" onClick={onClearFilters}>Limpiar Filtros</Button>
                  <Button onClick={onApplyFilters}>Aplicar Filtros</Button>
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </CardContent>
      </Card>
    </FormProvider>
  );
};

export default Filters;
